export const collectiveOperationsTranslations = {
  bo_external: {
    collective_operations: {
      name: 'Collective Operation |||| Collective Operations',
      tabs: {
        draft: {
          label: 'Draft',
        },
        in_progress: {
          label: 'In Progress',
        },
        history: {
          label: 'History',
        },
        migrated: {
          label: 'Migrated operations',
        },
      },
      fields: {
        id: 'Operation ID',
        operation_type: 'Type',
        type: 'Campaign Type',
        date: 'Date',
        total_gross_amount: 'Gross Amount',
        total_net_amount: 'Net Amount',
        number_of_eligible_employees: 'Eligible Employees',
        status: 'Status',
        created_at: 'Created At',
        updated_at: 'Updated At',
      },
      types: {
        campaign: 'Campaign',
        matching_contribution: 'Matching Contribution',
      },
      choices: {
        type: {
          matching_contribution: 'Matching Contribution',
          ccb_withdrawal: 'CCB Withdrawal',
        },
      },
    },
  },
};
